export const searchActions = {
  CLICK_SEARCH_OPTION: "CLICK_SEARCH_OPTION",
} as const;
